import { render, staticRenderFns } from "./VariableTile.vue?vue&type=template&id=2ed74086&scoped=true&"
import script from "./VariableTile.vue?vue&type=script&lang=js&"
export * from "./VariableTile.vue?vue&type=script&lang=js&"
import style0 from "./VariableTile.vue?vue&type=style&index=0&id=2ed74086&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ed74086",
  null
  
)

export default component.exports